module.exports = __webpack_public_path__ + "static/assets/a2287c8fce6d430522b550e223678c6a.png";